import { ProblemsSolvedDivider } from '../ProblemsSolvedDivider';
import styles from './ProblemsSolvedDescription.module.css';

type ProblemsSolvedDescriptionProps = {
  problemText: string;
  solutionText: string;
};

export const ProblemsSolvedDescription = ({ problemText, solutionText }: ProblemsSolvedDescriptionProps) => {
  return (
    <>
      <ProblemsSolvedDivider />
      <div className={styles.problemsSolvedDecriptionContainer}>
        <h3 className={styles.problemSolutionCardSubheading}>Problem</h3>
        <p className={styles.problemSolutionCardProblemText}>{problemText}</p>
      </div>
      <div className={styles.problemsSolvedDecriptionContainer} style={{ marginTop: 'auto' }}>
        <h3 className={styles.problemSolutionCardSubheading}>Solution</h3>
        <p className={styles.problemSolutionCardSolutionText}>{solutionText}</p>
      </div>
    </>
  );
};
